import { defineMessages } from "react-intl";

import TourDescriptor from "@app/component/flows/types/TourDescriptor";

const messages = defineMessages({
  step01: {
    id: "guides.resources.foldersTour.step01",
    defaultMessage: "Creating and Using Folders",
  },
  step01Description: {
    id: "guides.resources.foldersTour.step01.description",
    defaultMessage: "Folders help you organize pinned resources by category, team, or purpose.",
  },
  step02: {
    id: "guides.resources.foldersTour.step02",
    defaultMessage: "Creating a Folder",
  },
  step02Description: {
    id: "guides.resources.foldersTour.step02.description",
    defaultMessage: "Click the + icon next to <b>My Folders</b>.",
  },
  step03: {
    id: "guides.resources.foldersTour.step03",
    defaultMessage: "Creating a Folder",
  },
  step03Description: {
    id: "guides.resources.foldersTour.step03.description",
    defaultMessage: "Enter a folder name and press <b>Enter</b> or click a ✔︎ button.",
  },
  step04: {
    id: "guides.resources.foldersTour.step04",
    defaultMessage: "Creating a Folder",
  },
  step04Description: {
    id: "guides.resources.foldersTour.step04.description",
    defaultMessage: "🎉 Success! Now let's return to the root folder.",
  },
  step05: {
    id: "guides.resources.foldersTour.step05",
    defaultMessage: "Adding to Folder",
  },
  step05Description: {
    id: "guides.resources.foldersTour.step05.description",
    defaultMessage:
      "Drag and drop resources into the folder, or select a resource and choose Add to Folder. Let's click on Resource's triple dot menu to start.",
  },
  step06: {
    id: "guides.resources.foldersTour.step06",
    defaultMessage: "Adding to Folder",
  },
  step06Description: {
    id: "guides.resources.foldersTour.step06.description",
    defaultMessage: "Select <b>Add to Folder</b>",
  },
  step07: {
    id: "guides.resources.foldersTour.step07",
    defaultMessage: "Adding to Folder",
  },
  step07Description: {
    id: "guides.resources.foldersTour.step07.description",
    defaultMessage: "Select destination folder and click <b>Apply</b>.",
  },
  step08: {
    id: "guides.resources.foldersTour.step08",
    defaultMessage: "Viewing a folder",
  },
  step08Description: {
    id: "guides.resources.foldersTour.step08.description",
    defaultMessage: "Click a folder name to view or manage the resources inside.",
  },
  step09: {
    id: "guides.resources.foldersTour.step09",
    defaultMessage: "Tour Complete",
  },
  step09Description: {
    id: "guides.resources.foldersTour.step09.description",
    defaultMessage: "🎉 Congratulations! You've completed this tour.",
  },
});

export const foldersTourConfiguration: TourDescriptor = {
  id: "mmc-resources-folders",
  steps: [
    {
      id: "intro",
      description: messages.step01Description,
      title: messages.step01,
    },
    {
      id: "adding-1",
      description: messages.step02Description,
      options: {
        disableInteraction: false,
        showBackground: true,
        showButtons: false,
      },
      position: "right",
      selector: "[data-action-id=resources-create-folder]",
      title: messages.step02,
      waitForEvent: {
        eventType: "click",
        selector: "[data-action-id=resources-create-folder]",
      },
    },
    {
      id: "adding-2",
      description: messages.step03Description,
      options: {
        disableInteraction: false,
        expectRouteChange: true,
        showBackground: true,
        showButtons: false,
      },
      position: "right",
      selector: "[class*=Sidebar_newFolder]",
      title: messages.step03,
      waitForEvent: {
        eventType: "internal",
        selector: "Process: Resources -> Add Folder",
      },
    },
    {
      id: "adding-3",
      description: messages.step04Description,
      goToPathAfter: "/resources",
      title: messages.step04,
    },
    {
      id: "adding-to-folder-1",
      description: messages.step05Description,
      options: {
        disableInteraction: false,
        showBackground: true,
        showButtons: false,
      },
      position: "left",
      selector:
        "[class*=ResourceList_list] .mmc-js-resource-link [data-action-id=resource-item-more]",
      title: messages.step05,
      waitForEvent: {
        eventType: "click",
        selector:
          "[class*=ResourceList_list] .mmc-js-resource-link [data-action-id=resource-item-more]",
      },
    },
    {
      id: "adding-to-folder-2",
      description: messages.step06Description,
      options: {
        disableInteraction: false,
        showBackground: true,
        showButtons: false,
      },
      position: "left",
      selector: "[data-menu-id$=moveToFolder]",
      title: messages.step06,
      waitForEvent: {
        eventType: "click",
        selector: "[data-menu-id$=moveToFolder]",
      },
    },
    {
      id: "adding-to-folder-3",
      description: messages.step07Description,
      options: {
        disableInteraction: false,
        showBackground: false,
        showButtons: false,
      },
      position: "right",
      selector: "[class*=ActionsButton_moveToFolderModal] .ant-btn-primary",
      title: messages.step07,
      waitForEvent: {
        eventType: "click",
        selector: "[class*=ActionsButton_moveToFolderModal] .ant-btn-primary",
      },
    },
    {
      id: "viewing-folder",
      description: messages.step08Description,
      options: {
        disableInteraction: false,
        expectRouteChange: true,
        showBackground: true,
        showButtons: false,
      },
      position: "right",
      selector: "[class*=Sidebar_folder][href^='/resources/']",
      title: messages.step08,
      waitForEvent: {
        eventType: "click",
        selector: "[class*=Sidebar_folder][href^='/resources/']",
      },
    },
    {
      id: "completed",
      description: messages.step09Description,
      title: messages.step09,
    },
  ],
};
